import Http from "../commons/utils/Http";
import {errorHandling} from "../commons/utils/error";

class applicationsService {

    async getAll(page) {
        try {
            let response = await Http.get(`/applications/get-all?offset=${page}`, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getId(id) {
        try {
            let response = await Http.get(`/applications/get-by?field=id&value=${id}`, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async search(search) {
        try {
            let response = await Http.get(`/applications/search?search=${search}`, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async getApplicationsRoles() {
        try {
            let response = await Http.get(`/applications/get-all`, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async insert(data) {
        try {
            let response = await Http.post(`/applications`, data, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async update(data) {
        try {
            let response = await Http.put(`/applications`, data, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

    async delete(id) {
        try {
            let response = await Http.delete(`/applications/${id}`, Http.headers)
            return response
        } catch (e) {
            errorHandling(e)
        }
    }

}

export default new applicationsService();